
import { useMemo, useState } from "react";
import { FiSearch } from "react-icons/fi";
import {
  getEntityId,
  normalizeManuscriptIds,
} from "../../services/manuscriptMasterService";
import css from "./ManuscriptAssignmentField.module.css";

export default function ManuscriptAssignmentField({
  manuscripts = [],
  selectedIds = [],
  onChange,
}) {
  const [search, setSearch] = useState("");
  const normalizedIds = useMemo(
    () => normalizeManuscriptIds(selectedIds),
    [selectedIds],
  );
  const selectedSet = useMemo(
    () => new Set(normalizedIds),
    [normalizedIds],
  );

  const visibleManuscripts = useMemo(() => {
    const query = search.trim().toLocaleLowerCase("uk-UA");

    return manuscripts
      .filter((manuscript) => getEntityId(manuscript))
      .filter((manuscript) => {
        if (!query) return true;

        return String(manuscript?.bookName || "")
          .toLocaleLowerCase("uk-UA")
          .includes(query);
      })
      .sort((a, b) =>
        String(a?.bookName || "").localeCompare(
          String(b?.bookName || ""),
          "uk",
          { sensitivity: "base" },
        ),
      );
  }, [manuscripts, search]);

  const toggleManuscript = (manuscriptId) => {
    const nextIds = selectedSet.has(manuscriptId)
      ? normalizedIds.filter((id) => id !== manuscriptId)
      : [...normalizedIds, manuscriptId];

    onChange?.(nextIds);
  };

  return (
    <section className={css.assignment}>
      <div className={css.header}>
        <div>
          <h4 className={css.title}>Рукописи майстра</h4>
          <p className={css.description}>
            Оберіть один або декілька рукописів, які будуть показані для цього
            майстра.
          </p>
        </div>
        <span className={css.counter}>Обрано: {normalizedIds.length}</span>
      </div>

      <label className={css.search}>
        <FiSearch aria-hidden="true" />
        <span className={css.visuallyHidden}>Пошук рукопису</span>
        <input
          type="search"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Знайти рукопис за назвою"
        />
      </label>

      <div className={css.list} role="group" aria-label="Рукописи майстра">
        {visibleManuscripts.map((manuscript) => {
          const manuscriptId = getEntityId(manuscript);

          return (
            <label className={css.option} key={manuscriptId}>
              <input
                className={css.checkbox}
                type="checkbox"
                checked={selectedSet.has(manuscriptId)}
                onChange={() => toggleManuscript(manuscriptId)}
              />
              <span>{manuscript.bookName || "Рукопис без назви"}</span>
            </label>
          );
        })}

        {visibleManuscripts.length === 0 && (
          <p className={css.empty}>
            {manuscripts.length === 0
              ? "У системі ще немає рукописів."
              : "За цим запитом рукописів не знайдено."}
          </p>
        )}
      </div>
    </section>
  );
}
